module.exports = __webpack_public_path__ + "static/media/loogo.072dcbca.png";